


























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { TweenMax, Power3 } from "gsap";

@Component
export default class Project extends Vue {
  @Prop() msn!: any;
  title: any;
  initImg: any;
  desc: any;
  content: any;

  mounted() {
    this.title = document.querySelector(".project__title")!.children[0];
    this.initImg = document.querySelectorAll(".project__img-init--img");
    this.desc = document.querySelector(".project__desc");
    this.content = document.querySelector(".project__content");

    TweenMax.from(document.getElementById("project__container"), 1, {
      y: "100vh",
      transformOrigin: "left 50%",
      ease: Power3.easeOut
    });

    this.initImg.forEach((element: any, index: number) => {
      TweenMax.from(element, 0.5, {
        y: "110%",
        ease: Power3.easeOut,
        delay: 0.2 + index / 5
      });
    });

    TweenMax.from(this.title, 0.5, {
      y: "100%",
      ease: Power3.easeOut,
      delay: 0.5
    });

    TweenMax.from(this.desc, 0.5, {
      opacity: "0",
      ease: Power3.easeOut,
      delay: 0.7
    });

    TweenMax.from(this.content, 0.5, {
      opacity: "0",
      ease: Power3.easeOut,
      delay: 0.7
    });
    // TweenMax.fromTo(this.title, {
    //   y: "100%"
    // }, {
    //   y: "-100%",
    //   ease: Power3.easeOut,
    //   delay: 0.6,
    //   duration: 0.6,
    //   onComplete: () => {
    //     TweenMax.fromTo(this.title, {
    //       y: "100%"
    //     },{
    //       y: "0%",
    //       duration: 0.3
    //     });
    //   }
    // });
  }

  leave(el: any, done: any) {
    TweenMax.to(document.getElementById("project__container"), 0.5, {
      y: "100vh",
      ease: Power3.easeIn,
      onComplete: done
    });
  }
}
